import { render, staticRenderFns } from "./RecebimentoDetalhesOrigem.vue?vue&type=template&id=67fc9328"
import script from "./RecebimentoDetalhesOrigem.vue?vue&type=script&lang=js"
export * from "./RecebimentoDetalhesOrigem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports